import { createAction, props } from '@ngrx/store';

import { KrosUser } from '../services/auth/kros-user.model';

export const startAuthentication = createAction('[Auth] Start authentication');
export const logoutUser = createAction('[Auth] User logout');

export const setEmptyUser = createAction('[Auth] Clear user');
export const setUser = createAction('[Auth] Set user', props<{ user: KrosUser }>());
